import { DteRecibido } from "./DteRecibido";

export class RespuestaEstadoDte {
   id: string;
   codigoRespuesta: number;
   codigoRespuestaSii: number;
   descripcion: string;
   //dteRecibidoEnt:DteRecibido;
}
